import { t } from '@avalara/bat-apps-shared/i18n';
import { SBox, SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';

const PlanWrapper = styled.div`
  s-box {
    border: 2px var(--color-interaction-border-focus) solid;
    box-shadow: 0px 4px 4px rgb(var(--shadow-color-rgb) / 25%);
  }
`;

const IossOfferPlan = () => (
  <PlanWrapper>
    <SBox className='margin-bottom-sm margin-top-sm margin-left-lg margin-right-lg'>
      <div className='margin-all-sm margin-top-xs'>
        <h2 className='text-center'>{"Avalara's IOSS solution includes:"}</h2>

        <h3 className='margin-top-sm'>
          <SIcon name='check' className='margin-right-sm' />
          {t('client.headings.ioss-registration-and-identification-number')}
        </h3>
        <p className='margin-left-lg'>
          After you register, use your IOSS identification number for all shipments to the EU under &euro;150
        </p>

        <h3 className='margin-top-lg'>
          <SIcon name='check' className='margin-right-sm' />
          {t('client.headings.monthly-returns-filing')}
        </h3>
        <p className='margin-left-lg'>
          {t('client.general.file-returns-electronically-through-the-ioss-portal-of-the-e')}
          {"you're"} registered
        </p>

        <h3 className='margin-top-lg'>
          <SIcon name='check' className='margin-right-sm' />
          {t('client.headings.intermediary-services')}
        </h3>
        <p className='margin-left-lg'>
          {t('client.general.avalara-acts-as-your-ioss-intermediary-to-complete-registrat')}
        </p>
      </div>
    </SBox>
  </PlanWrapper>
);
export default IossOfferPlan;
